/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityListTemplate from './entity-list.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

import './entity-list.scss';

export default angular.module('agrolog.components.entityList', [])
    .directive('agEntityList', EntityListDirective)
    .name;

/*@ngInject*/
function EntityListDirective($compile, $templateCache, $q, $filter, $mdUtil, types, agTypes, entityService) {

    var linker = function (scope, element, attrs, ngModelCtrl) {

        var template = $templateCache.get(entityListTemplate);
        element.html(template);

        scope.ngModelCtrl = ngModelCtrl;
        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
        scope.searchParams = {
            searchText: ''
        };
        scope.entityAdded = false;
        scope.addedSearchText = '';

        scope.entityAdded = function () {
            scope.searchParams.searchText = scope.lastSearchText;
        };

        scope.$watch('tbRequired', function () {
            scope.updateValidity();
        });

        scope.$watch(() => ngModelCtrl.$modelValue, function() {
            if (ngModelCtrl.$modelValue && scope.entityList && ngModelCtrl.$modelValue.length !==  scope.entityList.length) {
                for (var i = scope.entityList.length - 1; i >= 0; i--) {
                    if (ngModelCtrl.$modelValue.indexOf(scope.entityList[i].id.id) == -1) {
                        scope.excludeEntityIds.push(scope.entityList[i].id.id);
                        scope.entityList.splice(i, 1);
                    }
                }
            }
        }, true);

        scope.fetchEntities = function(searchText) {
            scope.lastSearchText = searchText;
            var deferred = $q.defer();
            var limit = 50;
            var excludeIds = [];
            if (scope.entityList) {
                for (var i=0;i<scope.entityList.length;i++) {
                    excludeIds.push(scope.entityList[i].id.id);
                }
            }
            if (scope.excludeEntityIds && scope.excludeEntityIds.length) {
                excludeIds = excludeIds.concat(scope.excludeEntityIds);
            }
            limit += excludeIds.length;
            entityService.getEntitiesByNameFilter(scope.entityType, searchText, limit, {ignoreLoading: true}, scope.entitySubtype).then(
                 function success(result) {
                    if (result) {
                        if (excludeIds.length) {
                            var entities = [];
                            result.forEach(function(entity) {
                                if (excludeIds.indexOf(entity.id.id) == -1) {
                                    entities.push(entity);
                                }
                            });
                            deferred.resolve(entities);
                        } else {
                            deferred.resolve(result);
                        }
                    } else {
                        deferred.resolve([]);
                    }
                 },
                 function fail() {
                    deferred.reject();
                 }
            );
            return deferred.promise;
        };

        scope.updateValidity = function() {
            var value = ngModelCtrl.$viewValue;
            var valid = !scope.tbRequired || value && value.length > 0;
            ngModelCtrl.$setValidity('entityList', valid);
        };

        scope.spotSubTypeName = function(entityType, entitySubType) {
            if (entityType ==  types.entityType.asset) {
                if (entitySubType == agTypes.assetType.site) {
                    return 'ag.site.site-not-found';
                } else {
                    return 'asset';
                }
            } else if (entityType === types.entityType.device) {
                if (entitySubType === agTypes.deviceType.temperatureSensorLines) {
                    return 'ag.device.temperature-cable-not-found';
                } else if (entitySubType === agTypes.deviceType.moistureSensorLines) {
                    return 'ag.device.moisture-cable-not-found';
                } else if (entitySubType === agTypes.deviceType.co2SensorLines) {
                    return 'ag.device.co2-cable-not-found';
                } else {
                    return 'device'
                }
            } else {
                return 'entity'
            }
        };

        ngModelCtrl.$render = function () {
            destroyWatchers();
            var value = ngModelCtrl.$viewValue;
            scope.entityList = [];
            if (value && value.length > 0) {
                entityService.getEntities(scope.entityType, value).then(function (entities) {
                    scope.entityList = entities;
                    initWatchers();
                });
            } else {
                initWatchers();
            }
        };

        function initWatchers() {
            scope.entityTypeDeregistration = scope.$watch('entityType', function (newEntityType, prevEntityType) {
                if (!angular.equals(newEntityType, prevEntityType)) {
                    reload();
                }
            });
            scope.entitySubtypeDeregistration = scope.$watch('entitySubtype', function (newEntitySubtype, prevEntitySubtype) {
                if (!angular.equals(newEntitySubtype, prevEntitySubtype)) {
                    reload();
                }
            });
            scope.entityListDeregistration = scope.$watch('entityList', function () {
                var ids = [];
                if (scope.entityList && scope.entityList.length > 0) {
                    for (var i=0;i<scope.entityList.length;i++) {
                        ids.push(scope.entityList[i].id.id);
                    }
                }
                var value = ngModelCtrl.$viewValue;
                if (!angular.equals(ids, value)) {
                    ngModelCtrl.$setViewValue(ids);
                }
                scope.updateValidity();
            }, true);
        }

        function destroyWatchers() {
            if (scope.entityTypeDeregistration) {
                scope.entityTypeDeregistration();
                scope.entityTypeDeregistration = null;
            }
            if (scope.entitySubtypeDeregistration) {
                scope.entitySubtypeDeregistration();
                scope.entitySubtypeDeregistration = null;
            }
            if (scope.entityListDeregistration) {
                scope.entityListDeregistration();
                scope.entityListDeregistration = null;
            }
        }

        function reload() {
            scope.entityList = [];
            switch (scope.entityType) {
                case types.entityType.asset:
                    scope.selectEntityText = 'asset.select-asset';
                    scope.entityText = 'asset.asset';
                    scope.noEntitiesMatchingText = 'asset.no-assets-matching';
                    scope.entityRequiredText = 'asset.asset-required';
                    break;
                case types.entityType.device:
                    scope.selectEntityText = 'device.select-device';
                    scope.entityText = 'device.device';
                    scope.noEntitiesMatchingText = 'device.no-devices-matching';
                    scope.entityRequiredText = 'device.device-required';
                    break;
                case types.entityType.rule:
                    scope.selectEntityText = 'rule.select-rule';
                    scope.entityText = 'rule.rule';
                    scope.noEntitiesMatchingText = 'rule.no-rules-matching';
                    scope.entityRequiredText = 'rule.rule-required';
                    break;
                case types.entityType.plugin:
                    scope.selectEntityText = 'plugin.select-plugin';
                    scope.entityText = 'plugin.plugin';
                    scope.noEntitiesMatchingText = 'plugin.no-plugins-matching';
                    scope.entityRequiredText = 'plugin.plugin-required';
                    break;
                case types.entityType.tenant:
                    scope.selectEntityText = 'tenant.select-tenant';
                    scope.entityText = 'tenant.tenant';
                    scope.noEntitiesMatchingText = 'tenant.no-tenants-matching';
                    scope.entityRequiredText = 'tenant.tenant-required';
                    break;
                case types.entityType.customer:
                    scope.selectEntityText = 'customer.select-customer';
                    scope.entityText = 'customer.customer';
                    scope.noEntitiesMatchingText = 'customer.no-customers-matching';
                    scope.entityRequiredText = 'customer.customer-required';
                    break;
                case types.entityType.user:
                    scope.selectEntityText = 'user.select-user';
                    scope.entityText = 'user.user';
                    scope.noEntitiesMatchingText = 'user.no-users-matching';
                    scope.entityRequiredText = 'user.user-required';
                    break;
                case types.entityType.dashboard:
                    scope.selectEntityText = 'dashboard.select-dashboard';
                    scope.entityText = 'dashboard.dashboard';
                    scope.noEntitiesMatchingText = 'dashboard.no-dashboards-matching';
                    scope.entityRequiredText = 'dashboard.dashboard-required';
                    break;
                case types.entityType.alarm:
                    scope.selectEntityText = 'alarm.select-alarm';
                    scope.entityText = 'alarm.alarm';
                    scope.noEntitiesMatchingText = 'alarm.no-alarms-matching';
                    scope.entityRequiredText = 'alarm.alarm-required';
                    break;
            }
        }

        $compile(element.contents())(scope);

        $mdUtil.nextTick(function(){
            var inputElement = angular.element('input', element);
            inputElement.on('blur', function() {
                scope.inputTouched = true;
            } );
        });

    }

    return {
        restrict: "E",
        require: "^ngModel",
        link: linker,
        scope: {
            disabled:'=ngDisabled',
            tbRequired: '=?',
            entityType: '=',
            entitySubtype: '=?',
            excludeEntityIds: '=?'
        }
    };

}
